import { IBehavior } from '@/interfaces/Behavior';
import { EPaymentMethod } from '@/helpers/enums';
import { IPurchaseResponse } from '@/interfaces/Purchase';

const expiresAtMidNight = () => {
  const tomorrow: any = new Date(new Date().setDate(new Date().getDate() + 1));
  const expires: any = new Date(tomorrow.setHours(0, 1, 0, 0));

  return expires;
};

const expiresIn7Days = () => String(new Date(new Date().setDate(new Date().getDate() + 7)));

export default {
  setCaptchaValid(state: IBehavior, isCaptchaValid: boolean) {
    state.isCaptchaValid = isCaptchaValid;
  },
  setDeliveryAddressValid(state: IBehavior, isDeliveryAddressValid: boolean) {
    state.isDeliveryAddressValid = isDeliveryAddressValid;
  },
  setOfferLoaded(state: IBehavior, currentOfferLoaded: string) {
    state.checkoutLoaded
      .updateValue(currentOfferLoaded)
      .updateExpires(expiresAtMidNight())
      .setCookie();
  },
  setPaymentMethodSelected(state: IBehavior, paymentMethodSelected: EPaymentMethod) {
    state.paymentMethodSelected
      .updateValue(paymentMethodSelected)
      .updateExpires(expiresAtMidNight())
      .setCookie();
  },
  setOfferSelected(state: IBehavior, offerSelected: number) {
    state.offerSelected
      .updateValue(offerSelected)
      .updateExpires(expiresAtMidNight())
      .setCookie();
  },
  setPriceSelected(state: IBehavior, priceSelected: number) {
    state.priceSelected
      .updateValue(priceSelected)
      .updateExpires(expiresAtMidNight())
      .setCookie();
  },
  setPurchaseResponse(state: IBehavior, purchaseData: any) {
    let currentPurchaseResponse = state.purchaseResponse.value
      ? JSON.parse(state.purchaseResponse.value)
      : [];

    currentPurchaseResponse = currentPurchaseResponse.filter((purchaseResponse: any) => {
      return purchaseResponse.id !== purchaseData.id;
    });

    state.purchaseResponse
      .updateValue(JSON.stringify([...currentPurchaseResponse, purchaseData]))
      .updateExpires(expiresIn7Days())
      .setCookie();
  },
  setUUID(state: IBehavior, uuid: string) {
    state.uuid
      .updateValue(uuid)
      .updateExpires(expiresAtMidNight())
      .setCookie();
  },
  disablePay(state: IBehavior) {
    state.canPay = false;
  },
};
